"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultFormQuestionController = void 0;
const jsonAreSame_1 = __importDefault(require("../helpers/jsonAreSame"));
const createFormQuestionConfigBase_1 = __importDefault(require("../mutations/createFormQuestionConfigBase"));
exports.DefaultFormQuestionController = {
    updateAnswer: (answer, rule, patch) => {
        const newAnswer = Object.assign(Object.assign(Object.assign({}, answer), patch), { score: (rule === null || rule === void 0 ? void 0 : rule.score) || undefined });
        newAnswer.notApplicable = patch.notApplicable;
        return newAnswer;
    },
    compress: (c) => {
        return c.config;
    },
    areSame: (a, b) => {
        if (a.qId !== b.qId)
            return false;
        if (a.type !== b.type)
            return false;
        if (a.title !== b.title)
            return false;
        if (JSON.stringify(a.titleAlt) !== JSON.stringify(b.titleAlt))
            return false;
        if (a.enabled !== b.enabled)
            return false;
        if (a.parentQSetId !== b.parentQSetId)
            return false;
        // Compare answers ??!??
        const aConfig = a.config[a.type];
        const bConfig = b.config[b.type];
        if (!(0, jsonAreSame_1.default)(aConfig.richInfo, bConfig.richInfo))
            return false;
        if (!(0, jsonAreSame_1.default)(aConfig.richInfoAlt, bConfig.richInfoAlt))
            return false;
        if (aConfig.scoring !== bConfig.scoring)
            return false;
        return aConfig.enableNA === bConfig.enableNA;
    },
    isAllowed: () => {
        return true;
    },
    canScore: () => {
        return true;
    },
    canEnableNA: () => {
        return true;
    },
    createConfig: () => {
        return (0, createFormQuestionConfigBase_1.default)();
    },
    createExampleConfig: () => {
        return (0, createFormQuestionConfigBase_1.default)();
    },
};
exports.default = exports.DefaultFormQuestionController;
